import { Route, Routes } from "react-router-dom";
import { PurchaseOrdersPage } from "src/routes/developments/purchase-orders/PurchaseOrdersPage";
import {
  relativeTradesPath,
  tradesBidContractsPath,
  tradesPurchaseOrdersPath,
  tradesTradePartnersPath,
} from "src/routes/routesDef";
import { TradePartnersPage } from "src/routes/trade-partners/TradePartnersPage";
import { GlobalBidContractsPage } from "src/routes/trades/bid-contracts/GlobalBidContractsPage";

/**
 * `/trades/*` route tree, excluding `/trades/bid-packages/*` which is served by the data router
 * (`src/routing/domains/bidPackages.ts`).
 */
export function TradesLayout() {
  const rt = relativeTradesPath;

  return (
    <Routes>
      <Route path={rt(tradesTradePartnersPath)} element={<TradePartnersPage />} />
      <Route path={rt(tradesPurchaseOrdersPath)} element={<PurchaseOrdersPage isGlobal={true} isTrades={true} />} />
      <Route path={rt(tradesBidContractsPath)} element={<GlobalBidContractsPage />} />
    </Routes>
  );
}
